import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { levels } from "../../../../common/parameters";
import Icon from "../../../icon";

import { Flag, ExperienceFlag } from "./styles";
import messages from "./messages";
import { IProps } from "./interfaces";

const BackPolygon = () => (
    <svg className={"Back"} width="8" height="6">
        <polygon points="0,0 8,0 0,6" />
    </svg>
);

const Flags = ({ browse, plan, homeworkLastResults, homeworkTotalResults }: IProps) => {
    const { formatMessage, locale } = useIntl();
    return (
        <>
            {browse && plan.meta.teaching.level !== undefined && (
                <Flag locale={locale}>
                    {
                        levels(formatMessage)[levels(formatMessage).findIndex(i => +i.value === +plan.meta.teaching.level!)]
                            .label
                    }
                    <BackPolygon />
                </Flag>
            )}
            {!browse && plan.shared && !plan.public && (
                <Flag locale={locale}>
                    <Icon i="meta" />
                    <FormattedMessage {...messages.labeled} />
                    <BackPolygon />
                </Flag>
            )}
            {!browse && plan.shared && plan.public && !plan.accepted && (
                <Flag locale={locale}>
                    <Icon i="clock" />
                    <FormattedMessage {...messages.publicationInProgress} />
                    <BackPolygon />
                </Flag>
            )}
            {!browse && plan.shared && plan.public && plan.accepted && (
                <Flag locale={locale}>
                    <Icon i="publish" />
                    <FormattedMessage {...messages.listed} />
                    <BackPolygon />
                </Flag>
            )}
            {!!homeworkTotalResults && (
                <Flag locale={locale}>
                    <FormattedMessage {...messages.solution} values={{ total: homeworkTotalResults }} />
                    <BackPolygon />
                </Flag>
            )}
            {!!homeworkTotalResults && !!homeworkLastResults && homeworkTotalResults !== homeworkLastResults && (
                <ExperienceFlag locale={locale}>
                    <span>+ {homeworkTotalResults - homeworkLastResults}</span>
                    <BackPolygon />
                </ExperienceFlag>
            )}
            {browse && plan.experience?.enabled && (
                <ExperienceFlag locale={locale}>
                    <FormattedMessage {...messages.experience} />
                    <BackPolygon />
                </ExperienceFlag>
            )}
        </>
    );
}

export default Flags;
